import type { ChildrenProps } from "../types";

export function StatsLabel({ children }: ChildrenProps) {
	/** Render */
	return <p className="label">{children}</p>;
}
